import { useEffect, useLayoutEffect, useState } from "react";
import IntelLayout from "@components/layout/layout";
import Header from "./components/Header";
import ProfileDetails from "./components/ProfileDetails";
import styles from "./PortProfile.module.scss";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { useLocation, useHistory } from "react-router-dom";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { portsEvent, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { getEventName, getUserActivePlan, isProfileAccess } from "@helpers/profileHelper";

const PortProfile = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [panelList, setPanelList] = useState([]);
  const { search: searchUrlParams, pathname } = useLocation();
  const history = useHistory();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const profileName = new URLSearchParams(searchUrlParams).get("profileName");

  useEffect(() => {
    trademoTrackingEvents(getEventName(profileTypeEnum.ports, portsEvent.landing), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  }, [dataSource, pathname]);

  useLayoutEffect(() => {
    const profileAccess = isProfileAccess(profileName);
    if (!profileAccess?.port) {
      history.push("/sample-ports");
    }
  }, [profileName, history]);

  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"portProfile"}>
      <div className={styles.portContainer}>
        <Header />
        <ProfileDetails panelList={panelList} setPanelList={setPanelList} />
      </div>
    </IntelLayout>
  );
};

export default PortProfile;
